import React, { useState, useEffect, useRef } from 'react';
import style from './NonFaceWithdraw.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import URL from "../../../../constants/url";
import { useNavigate } from "react-router-dom";
import Modal from "../../../../components/comm/Modal"
import imgChatbot from "../../../../images/user/i_chatbot_02.svg"
import { actionRemoveUser, reqDpRemoveUser } from '../../../../assets/js/comm';
import ToastPopup from '../../../../components/comm/ToastPopup';


const NonFaceWithdraw = () => {

    const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

    const navigate = useNavigate();

    //체크박스
    const [check, setCheck] = useState(false);

    //토스트메시지
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    //모달창
    const [isOpen, setIsOpen] = useState(false);

    const withdrawBtn = ()=> {
        if(!check) {
            setToastMessage("You must agree to the instructions \n to withdraw.");
            setToast(true);
            return;
        }
        setIsOpen(!isOpen);
    };

    const handleCheck = (e) => {
        const checked = e.target.checked;
        setCheck(checked);
    };

    const handleWithdraw = async () => {
        if(!check) {
            setToastMessage("You must agree to the instructions \n to withdraw.");
            setToast(true);
            return;
        }
        await reqDpRemoveUser(loginUser.usrUid)
            .then( res => {
                setToastMessage("Withdrawal processing has been completed.");
                setToast(true);
                setIsOpen(false);
                actionRemoveUser(loginUser);
            })
            .catch( err => {
                //actionRemoveUser(loginUser);// 에러가 난 경우는 보통.. 이미 삭제된 경우이니, 애프터케어 서비스도 탈퇴처리.. 필요시..
                setToastMessage("An error has occurred. \n You will now be redirected to the login screen.");
                setToast(true);
                // actionRemoveUser 를 걸어주면 아래 코드들은 콘솔로그 전까지 삭제 할것!
                localStorage.setItem('jToken', '');
                sessionStorage.setItem('loginUser', JSON.stringify({}));
                localStorage.setItem("AFTCR_CRTFC_TKN", "");
                window.location.href = URL.MAIN;
                console.log(err);
            })
    };

    return (
        <>
            <HeadSub title="Delete Account" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                <div className={style['mid-box']}>
                        <div className={style['top']}>
                            <object data={imgChatbot} className='ani-float' aria-hidden='true'></object>
                        </div>
                        <div className={style['mid']}>
                            <strong>Account Deletion Guide</strong>
                        </div>
                        <div className={style['botm']}>
                            <ul>
                                <li>
                                    <p>When you delete your account, all account information and personal data will be permanently deleted.</p>
                                </li>
                                <li>
                                    <p>After deletion, it will not be possible to recover your account or any associated data.</p>
                                </li>
                                <li>
                                    <p>Inquiry or error report posts will be retained for up to 3 years in accordance with relevant laws before being deleted.</p>
                                </li>
                            </ul>
                        </div>

                    </div>


                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box" data-height="auto">
                        <div className="inner-box">
                            <div className='btn-layout' data-btn-num="1" data-btn-direction="column">

                            <div className='chkbox-custom m-r-auto' data-chkbox='basic'>
                                    <input type="checkbox" id='chkId'
                                           checked={check}
                                           onChange={handleCheck}
                                    />
                                    <label htmlFor="chkId">
                                        <div className={style['txt-box']}>
                                            <p>I have read and understood all of the above information.</p>
                                        </div>
                                    </label>
                                </div>
                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={withdrawBtn}>
                                    <span>Delete Account</span>
                                </button>

                            </div>
                        </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}

                </div>
            </div>


            <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>Are you really going to Delete Account?</p>
                        </div>
                        <div className='sub-box'>
                            <span>
                               Once you request withdrawal, <br/> it cannot be reversed.
                            </span>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={() => setIsOpen(false)}>
                                <span>No</span>
                            </button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={handleWithdraw}>
                                <span>YES</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};

export default NonFaceWithdraw;
